import { DocumentSubType } from '/@/modules/document/enums/DocumentSubType';

export class VaultDocumentSubType extends DocumentSubType {
  static IDENTIFICATION_BIRTH_CERTIFICATE = super.IDENTIFICATION_BIRTH_CERTIFICATE;

  static IDENTIFICATION_DRIVERS_LICENSE = super.IDENTIFICATION_DRIVERS_LICENSE;

  static IDENTIFICATION_HEALTH_INSURANCE_CARD = super.IDENTIFICATION_HEALTH_INSURANCE_CARD;

  static IDENTIFICATION_PASSPORT = super.IDENTIFICATION_PASSPORT;

  static IDENTIFICATION_OTHERS = super.IDENTIFICATION_OTHERS;

  static ASSET_APPRAISAL = super.ASSET_APPRAISAL;

  static ASSET_BANK_STATEMENTS = super.ASSET_BANK_STATEMENTS;

  static ASSET_FIREARM_LICENSE = super.ASSET_FIREARM_LICENSE;

  static ASSET_OTHERS = super.ASSET_OTHERS;

  static ASSET_POLICY_CONTRACT = super.ASSET_POLICY_CONTRACT;

  static ASSET_PRE_ARRANGEMENT_CONTRACT = super.ASSET_PRE_ARRANGEMENT_CONTRACT;

  static ASSET_PRE_ARRANGEMENT_CEMETERY_PROPERTY_DEED = super
    .ASSET_PRE_ARRANGEMENT_CEMETERY_PROPERTY_DEED;

  static ASSET_PROPERTY_TITLE = super.ASSET_PROPERTY_TITLE;

  static ASSET_STOCK_OPTIONS = super.ASSET_STOCK_OPTIONS;

  static ASSET_TAX_REPORT = super.ASSET_TAX_REPORT;

  static BANKING_BANK_STATEMENT = super.BANKING_BANK_STATEMENT;

  static BANKING_OTHERS = super.BANKING_OTHERS;

  static BANKING_CHEQUE = super.BANKING_CHEQUE;

  static LIABILITY_APPRAISAL = super.LIABILITY_APPRAISAL;

  static LIABILITY_BANK_STATEMENTS = super.LIABILITY_BANK_STATEMENTS;

  static LIABILITY_BILL = super.LIABILITY_BILL;

  static LIABILITY_FUNERAL_CONTRACT = super.LIABILITY_FUNERAL_CONTRACT;

  static LIABILITY_FUNERAL_INVOICE = super.LIABILITY_FUNERAL_INVOICE;

  static LIABILITY_LEASE = super.LIABILITY_LEASE;

  static LIABILITY_OTHERS = super.LIABILITY_OTHERS;

  static LIABILITY_TAX = super.LIABILITY_TAX;

  static LIABILITY_EXECUTOR_DISBURSEMENT_INVOICE = super.LIABILITY_EXECUTOR_DISBURSEMENT_INVOICE;

  static ESTATE_AFFIDAVIT_OF_EXECUTION = super.ESTATE_AFFIDAVIT_OF_EXECUTION;

  static ESTATE_AFFIDAVIT_OF_EXECUTION_SIGNED = super.ESTATE_AFFIDAVIT_OF_EXECUTION_SIGNED;

  static ESTATE_REPRESENTATION_AGREEMENT = super.ESTATE_REPRESENTATION_AGREEMENT;

  static ESTATE_REPRESENTATION_AGREEMENT_SIGNED = super.ESTATE_REPRESENTATION_AGREEMENT_SIGNED;

  static ESTATE_SHIPPING_LABEL = super.ESTATE_SHIPPING_LABEL;

  static ESTATE_CERTIFIED_TRUE_MARRIAGE_CERTIFICATE = super
    .ESTATE_CERTIFIED_TRUE_MARRIAGE_CERTIFICATE;

  static ESTATE_SPOUSE_DEATH_CERTIFICATE = super.ESTATE_SPOUSE_DEATH_CERTIFICATE;

  static ESTATE_DIVORCE_CERTIFICATE = super.ESTATE_DIVORCE_CERTIFICATE;

  static ESTATE_GRANT_OF_PROBATE = super.ESTATE_GRANT_OF_PROBATE;

  static ESTATE_INFORMATION_RETURN = super.ESTATE_INFORMATION_RETURN;

  static ESTATE_POWER_OF_ATTORNEY_HEALTHCARE_DIRECTIVE = super
    .ESTATE_POWER_OF_ATTORNEY_HEALTHCARE_DIRECTIVE;

  static ESTATE_POWER_OF_ATTORNEY_HEALTHCARE_DIRECTIVE_SIGNED = super
    .ESTATE_POWER_OF_ATTORNEY_HEALTHCARE_DIRECTIVE_SIGNED;

  static ESTATE_POWER_OF_ATTORNEY_PERSONAL_CARE = super.ESTATE_POWER_OF_ATTORNEY_PERSONAL_CARE;

  static ESTATE_POWER_OF_ATTORNEY_PERSONAL_CARE_SIGNED = super
    .ESTATE_POWER_OF_ATTORNEY_PERSONAL_CARE_SIGNED;

  static ESTATE_POWER_OF_ATTORNEY_PROPERTY = super.ESTATE_POWER_OF_ATTORNEY_PROPERTY;

  static ESTATE_POWER_OF_ATTORNEY_PROPERTY_SIGNED = super.ESTATE_POWER_OF_ATTORNEY_PROPERTY_SIGNED;

  static ESTATE_ADVANCED_HEALTH_CARE_DIRECTIVE = super.ESTATE_ADVANCED_HEALTH_CARE_DIRECTIVE;

  static ESTATE_ADVANCED_HEALTH_CARE_DIRECTIVE_SIGNED = super
    .ESTATE_ADVANCED_HEALTH_CARE_DIRECTIVE_SIGNED;

  static ESTATE_ENDURING_POWER_OF_ATTORNEY = super.ESTATE_ENDURING_POWER_OF_ATTORNEY;

  static ESTATE_ENDURING_POWER_OF_ATTORNEY_SIGNED = super.ESTATE_ENDURING_POWER_OF_ATTORNEY_SIGNED;

  static ESTATE_PERSONAL_DIRECTIVE = super.ESTATE_PERSONAL_DIRECTIVE;

  static ESTATE_PERSONAL_DIRECTIVE_SIGNED = super.ESTATE_PERSONAL_DIRECTIVE_SIGNED;

  static ESTATE_POWER_OF_ATTORNEY_PROPERTY_AND_PERSONAL_CARE = super
    .ESTATE_POWER_OF_ATTORNEY_PROPERTY_AND_PERSONAL_CARE;

  static ESTATE_POWER_OF_ATTORNEY_PROPERTY_AND_PERSONAL_CARE_SIGNED = super
    .ESTATE_POWER_OF_ATTORNEY_PROPERTY_AND_PERSONAL_CARE_SIGNED;

  static ESTATE_SCANNED_MARRIAGE_CERTIFICATE = super.ESTATE_SCANNED_MARRIAGE_CERTIFICATE;

  static ESTATE_STATUTORY_DECLARATION_OF_COMMON_LAW_UNION = super
    .ESTATE_STATUTORY_DECLARATION_OF_COMMON_LAW_UNION;

  static ESTATE_WILL = super.ESTATE_WILL;

  static ESTATE_CODICILS = super.ESTATE_CODICILS;

  static ESTATE_OTHERS = super.ESTATE_OTHERS;

  static TAX_CANADA_PENSION_PLAN = super.TAX_CANADA_PENSION_PLAN;

  static TAX_CPP_SURVIVORS_PENSION = super.TAX_CPP_SURVIVORS_PENSION;

  static TAX_NOTICE_OF_ASSESSMENT = super.TAX_NOTICE_OF_ASSESSMENT;

  static TAX_OTHERS = super.TAX_OTHERS;

  static TAX_REPORT = super.TAX_REPORT;

  static TAX_UPDATE_CRA_RECORDS = super.TAX_UPDATE_CRA_RECORDS;
}
